import { useState } from 'react';

import RequestOTP from '../RequestOTP';
import { type View } from '../types';
import VerifyOTP from '../VerifyOTP';

type Props = {
  creatorSlug?: string;
  onChangeView: (view: View) => void;
  phoneNumber?: string;
  isCreator?: boolean;
  hasFinishedOnboarding?: boolean;
};

const SignInWithPhone: React.FC<Props> = ({
  isCreator,
  creatorSlug,
  phoneNumber: initialPhoneNumber,
  hasFinishedOnboarding,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [country, setCountry] = useState('');
  const [recipient, setRecipient] = useState('');
  const [canSendViaEmail, setCanSendViaEmail] = useState(false);

  const handleSentCode: Parameters<typeof RequestOTP>[0]['onSuccess'] = (otpData) => {
    setPhoneNumber(otpData.phoneNumber);
    setCountry(otpData.country);
    setRecipient(otpData.recipient);
    setCanSendViaEmail(otpData.canSendViaEmail);
  };

  if (!phoneNumber) {
    return <RequestOTP onSuccess={handleSentCode} initialPhoneNumber={initialPhoneNumber} />;
  }

  return (
    <VerifyOTP
      phoneNumber={phoneNumber}
      recipient={recipient}
      country={country}
      authCodeLength={6}
      canSendViaEmail={canSendViaEmail}
      creatorSlug={creatorSlug}
      isCreator={isCreator}
      hasFinishedOnboarding={hasFinishedOnboarding}
    />
  );
};

export default SignInWithPhone;
